import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { JsonFormaterInput } from "../../../theme/Component/JsonFormaterInput";
import { _PdfLibraryFactoryItem } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { PrintJson } from "../../../theme/Component/PrintJson";

interface Props {
    IDPdfLibraryFactory: number;
}


export const PdfLibraryFactoryitems = ({ IDPdfLibraryFactory }: Props) => {

    const pdf = useDataBean(_PdfLibraryFactoryItem);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [modalitems, setModalitems] = useState<any>({ name: "Items", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDPdfLibraryFactory])

    const getLista = () => {
        const x = {
            "IDPdfLibraryFactory": IDPdfLibraryFactory,
            // "State": 1
        }
        pdf.instance.getPdfLibraryFactoryItemCatalogPorPropiedades(x, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }




    const create = () => {
        pdf.setBean({
            IDPdfLibraryFactory: IDPdfLibraryFactory,
            State: 1,

        });
        setModal({ ...modal, "view": true });
    }

    const eliminarItem = () => {
        pdf.bean.State = 2;
        //console.log(PaymentMethod.bean);
        editaItem();
        setModalC({ ...modalC, ['view']: false });
    }

    const editaItem = () => {
        //console.log(PaymentMethod.bean);
        pdf.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPdfLibraryFactoryItem', visible: true },
        { title: 'Orden del item', property: 'ItemOrden', visible: true },
        { title: 'JSON', property: 'JSONData', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Tipo de Elemento', property: 'TypeElement', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Plantilla PDF">
            <div className="row">
                <div className="col-md-12">
                    {/* <PrintJson json={pdf.bean} /> */}
                    <BasicTable body={lista} head={head} rowSet={pdf.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            {/* <div className="col-md-12">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={MessageTemplate.bean.IDProcessType} onChange={(e: any) => { MessageTemplate.setBean({ ...MessageTemplate.bean, "IDProcessType": e }) }} />
                            </div> */}
                            <div className="col-md-6">
                                <label>Orden Item</label>
                                <input type="text" name="ItemOrden" className="form-control" value={pdf.bean.ItemOrden} onChange={pdf.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Tipo</label>

                                <select className="form-control" value={pdf.bean.TypeElement} onChange={(e) => { pdf.setBean({ ...pdf.bean, ['TypeElement']: e.target.value }) }}>
                                    <option value={0}>...</option>
                                    <option value={100}>TITULO</option>
                                    <option value={101}>PARRAFO</option>
                                    <option value={102}>TABLA</option>
                                    <option value={103}>FIRMA</option>
                                    <option value={104}>CELDA</option>
                                </select>
                            </div>

                            <div className="col-md-12">

                                <JsonFormaterInput rows={20} inputType="string" value={pdf.bean.JSONData} onChange={(e) => { pdf.setBean({ ...pdf.bean, ['JSONData']: e }) }} returnType="string" _label="Respuesta" />

                            </div>

                            <div className="col-md-12">
                                <label>TITULO</label>
                                <input type="text" name="ItemOrden" className="form-control" value={pdf.bean.ItemOrden} onChange={pdf.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>VALOR</label>
                                <input type="text" name="ItemOrden" className="form-control" value={pdf.bean.ItemOrden} onChange={pdf.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>VALOR</label>
                                <input type="text" name="ItemOrden" className="form-control" value={pdf.bean.ItemOrden} onChange={pdf.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={eliminarItem}>
                        <strong>Eliminar item {pdf.bean.Name}</strong>
                    </ModalConfirm>

                </div>

            </div>
        </BasicPage>
    )
}